export * from './clone.pipe';
